var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-img"},_vm._l((_vm.formattedValue),function(item,index){return _c('img',{key:item + index,attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }